import { useEffect } from 'react';
const useScriptTag = ({ id, src }, callback) => {
    useEffect(() => {
        const scriptTag = document.getElementById(id);
        if (!scriptTag) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = src;
            script.id = id;
            document.body.appendChild(script);
            script.onload = () => {
                callback && callback(true);
            };
        }
        else {
            callback && callback(false);
        }
    }, [id, src, callback]);
};
export default useScriptTag;
//# sourceMappingURL=index.js.map